import { Accordion } from '@base-ui/react/accordion';
import styles from './QuestionAccordion.module.css';
import classes from "../ReleaseActivityPage/ReleaseActivityPage.module.css";
import {
    BLANK_REGEX,
    BLANK_REGEX_NEW, BLANK_REGEX_WRAPPED, BLANK_REGEX_WRAPPED_NEW,
    POINTS_TEXT, POLL_TYPE,
    QUESTION_PARTICIPATION_POINT_LABEL, QUESTION_POINT_LABEL,
    QUESTION_TYPES, UNGRADED_Cap
} from "../../utils/constants";
import reactStringReplace from "react-string-replace";
import React, {Fragment, useState} from "react";
import {LatexHTMLInline, LatexInline} from "../../components/Tiptap/latexParser";
import {ReactComponent as ArrowDown} from "../../images/YuJa_arrow_down_icon.svg";
import {ReactComponent as ArrowUp} from "../../images/YuJa_arrow_up_icon.svg";
import {ReactComponent as POINTS_ICON} from "../../images/weightage_purple.svg"
import {questionCodeToName, questionCodeToSVG, questionError} from "../../utils/questionUtils";
import {YuJaTooltip} from "../../components/standardization/YuJaTooltip";
import {
    getQuestionCorrectnessPoints,
    getQuestionParticipationPoints,
    getQuestionWeightage, getSafeIframeSrc, isSafeIframeSrc,
    questionHasWeightage
} from "../../utils/helpers";
import ImageViewer from "../JoinQuizPage/ImageViewer";
import ActivityEditorClasses from "./ActivityEditor.module.css";
import ClickableImageNew from "../../questions/CI/ClickableImageNew";
import ViewLiveRespCountChart from "../ReleaseActivityPage/ViewLiveRespCountChart";
import ViewLiveRespRK from "../ReleaseActivityPage/ViewLiveRespRK";
import ViewLiveRespMH from "../ReleaseActivityPage/ViewLiveRespMH";
import parse from "html-react-parser";
import {useClassResultsAnalysisManager} from "../../hooks/useClassResultsAnalysisManager";
import {YuJaCheckbox} from "../../components/standardization/YuJaCheckbox";
import useWindowDimensions from "../../hooks/useWindowDimensions";

export default function QuestionAccordion({fakePoll={}, importedQuestions=[], setImportedQuestions}) {
    const {width: windowWidth} = useWindowDimensions();
    const {questions=[]} = fakePoll;
    const [openedQuestionNo, setOpenedQuestionNo] = useState(0);
    const [responses, ] = useState([]);

    const {responseCountData} = useClassResultsAnalysisManager(fakePoll, responses);
    const isSelectable = !!setImportedQuestions;

    const renderAllCorrectOptions = (question, blankName) => {
        if (!question.correctAnswers.hasOwnProperty(blankName) || !question.correctAnswers[blankName].length) {
            return "";
        }


        if (question.correctAnswers[blankName].length === 1) {
            return question.correctAnswers[blankName];
        }

        let allOpts = "";
        for(let element of question.correctAnswers[blankName]) {
            if(allOpts !== "") {
                allOpts += " / " + element;
            }
            else {
                allOpts += element;
            }
        }
        return allOpts;
    };


    const validateQuestion = (question) => {
        if (question.questionType === "UNSUPPORTED") {
            return {title: "Unsupported Question", description: "This question type is not supported and cannot be imported."};
        }
        let {quesError} = questionError(question, POLL_TYPE.MERGED_POLL);

        if (!!quesError) {
            return {
                title: "Missing Information",
                description: "Some information for this question could not be retrieved. You can still import it and edit the details in Engage."
            }
        } else {
            return {
                title: "",
                description: ""
            }
        }
    }

    return (
        <Accordion.Root
            className={styles.column}
            style={{
                gap: 5,
                flex: 1,
                minWidth: 0,
                marginTop: 10,
            }}
            value={openedQuestionNo > 0 ? [openedQuestionNo] : []}
            onValueChange={(val) => {
                if (!val.length) {
                    setOpenedQuestionNo(-1);
                } else {
                    setOpenedQuestionNo(val[0]);
                    // setCurrentQuestionNo(val[0]);
                }
            }}
        >
            {questions.map((question, index) => {
                const {serialNo, queTitle, questionType, weightage, hasBlankRestriction=true} = question;

                let importedQuestion = importedQuestions.find(i => i.serialNo === serialNo);
                let checked = !!importedQuestion;
                let totalPoints = getQuestionWeightage(question);

                let regex = new RegExp("", "g");

                let {title: errorTitle, description: errorDesc } = validateQuestion(question);

                let liveResponses = responseCountData[index];

                if (questionType === QUESTION_TYPES.FITB.name) {
                    let blankNameArr = Object.keys(question.correctAnswers).map(str => `\\(${str}\\)`);
                    if (!!weightage) {
                        regex = new RegExp(`(${blankNameArr.join("|")})`, "g");
                    } else {
                        regex = hasBlankRestriction ? BLANK_REGEX_NEW : BLANK_REGEX
                    }

                }

                return (
                    <Accordion.Item key={index} value={serialNo} className={styles.questionCard}>
                        <Accordion.Header
                            className={styles.questionCardHeader}
                            style={{gap: 15}}
                        >
                            {isSelectable &&
                                <YuJaCheckbox
                                    checked={checked}
                                    disabled={questionType === "UNSUPPORTED"}
                                    onChange={(checked, e) => {
                                        e.stopPropagation();
                                        let copy = JSON.parse(JSON.stringify(importedQuestions));
                                        copy = copy.filter(i => i.serialNo !== serialNo);
                                        if (checked) {
                                            copy.push(JSON.parse(JSON.stringify(question)));
                                            copy = copy.sort((a, b) => a.serialNo - b.serialNo);
                                        }
                                        setImportedQuestions(copy);
                                    }}
                                    style={{marginRight: 10}}
                                />
                            }

                            <div className={styles.questionCardHeaderLayout}>
                                <div
                                    className={classes.column}
                                    style={
                                        windowWidth > 640
                                            ? {flex: 1, minWidth: 0, rowGap: 10}
                                            : {width: "100%", rowGap: 10}
                                    }
                                >
                                    <Accordion.Trigger
                                        className={styles.row}
                                        style={{gap: 10, flex: 1, minWidth: 0}}
                                    >
                                        {openedQuestionNo === serialNo ?
                                            <ArrowUp style={{flexShrink: 0}}/> :
                                            <ArrowDown style={{flexShrink: 0}}/>
                                        }
                                        <span className={`${styles.questionIndexBox}`}>
                                            {serialNo}
                                        </span>
                                        <span style={{
                                            flex: 1,
                                            minWidth: 0,
                                            fontWeight: "500",
                                            color: "#000",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            textAlign: "left"
                                        }}>
                                            {questionType === QUESTION_TYPES.FITB.name &&
                                                reactStringReplace(queTitle, regex, (blank, i) => {
                                                    return <Fragment key={i}>{"______"}</Fragment>;
                                                })
                                            }

                                            {questionType !== QUESTION_TYPES.FITB.name &&
                                                <LatexInline>{queTitle}</LatexInline>
                                            }

                                        </span>

                                    </Accordion.Trigger>


                                    {windowWidth <= 640 &&
                                        <div
                                            className={styles.row}
                                            style={{flexWrap: "wrap", rowGap: 8}}
                                        >
                                            {questionType !== "UNSUPPORTED" &&
                                                <>
                                            <span className={styles.iconWrapper} style={{marginRight: 5}}>
                                                {questionCodeToSVG(questionType, true, 16)}
                                            </span>
                                                    <span>
                                                {questionCodeToName(questionType)}
                                            </span>

                                                    <div className={styles.rowSeparator}/>
                                                </>
                                            }

                                            <YuJaTooltip
                                                disableTab={true}
                                                disabled={!getQuestionParticipationPoints(question)}
                                                text={parse(
                                                    `<span>
                                                            ${getQuestionCorrectnessPoints(question)} ${QUESTION_POINT_LABEL}</br> 
                                                            ${getQuestionParticipationPoints(question)} ${QUESTION_PARTICIPATION_POINT_LABEL}</span>`
                                                )}
                                            >
                                                <div className={styles.row}>
                                            <span className={styles.iconWrapper} style={{marginRight: 5}}>
                                                <POINTS_ICON/>
                                            </span>
                                                    <span>
                                                {questionHasWeightage(question)
                                                    ? `${getQuestionWeightage(question)} ${POINTS_TEXT}`
                                                    : UNGRADED_Cap
                                                }
                                            </span>
                                                </div>
                                            </YuJaTooltip>
                                        </div>
                                    }

                                    {!!errorTitle &&
                                        <div className={classes.row} style={{gap: 10, width: "100%", flexShrink: 0}}>
                                            <WarnIcon style={{flexShrink: 0}}/>
                                            <div style={{flex: 1, color: "#565656", fontWeight: "500", textAlign: "start"}}>
                                                <strong>{errorTitle}</strong>
                                                :&nbsp;
                                                {errorDesc}
                                            </div>

                                        </div>
                                    }

                                </div>
                                {windowWidth > 640 &&
                                    <div
                                        className={styles.row}
                                        style={{flexWrap: "wrap", rowGap: 8}}
                                    >
                                        {questionType !== "UNSUPPORTED" &&
                                            <>
                                            <span className={styles.iconWrapper} style={{marginRight: 5}}>
                                                {questionCodeToSVG(questionType, true, 16)}
                                            </span>
                                                <span>
                                                {questionCodeToName(questionType)}
                                            </span>

                                                <div className={styles.rowSeparator}/>
                                            </>
                                        }

                                        <YuJaTooltip
                                            disableTab={true}
                                            disabled={!getQuestionParticipationPoints(question)}
                                            text={parse(
                                                `<span>
                                                            ${getQuestionCorrectnessPoints(question)} ${QUESTION_POINT_LABEL}</br> 
                                                            ${getQuestionParticipationPoints(question)} ${QUESTION_PARTICIPATION_POINT_LABEL}</span>`
                                            )}
                                        >
                                            <div className={styles.row}>
                                            <span className={styles.iconWrapper} style={{marginRight: 5}}>
                                                <POINTS_ICON/>
                                            </span>
                                                <span>
                                                {questionHasWeightage(question)
                                                    ? `${getQuestionWeightage(question)} ${POINTS_TEXT}`
                                                    : UNGRADED_Cap
                                                }
                                            </span>
                                            </div>
                                        </YuJaTooltip>
                                    </div>
                                }

                            </div>





                        </Accordion.Header>

                        <Accordion.Panel className={styles.questionCardBody}>
                            {questionType === QUESTION_TYPES.FITB.name &&
                                <span className={styles.row} style={{flexWrap: "wrap", gap: 0}}>
                                   {queTitle.split(question.hasBlankRestriction ? BLANK_REGEX_WRAPPED_NEW : BLANK_REGEX_WRAPPED).map((str, i) => { // /(\(.*?\))/g
                                       let re = new RegExp(question.hasBlankRestriction ? BLANK_REGEX_NEW : BLANK_REGEX); // /\([^\(\)]+\)/g
                                       if (!re.test(str)) {
                                           const oneLine = str.replace(/[\r\n]/g, " @newLine ");
                                           const wordArr = oneLine ? oneLine.split(" ") : [];
                                           return (
                                               <Fragment key={i}>
                                                   {wordArr.map((s, idx) => (
                                                       <Fragment key={idx}>
                                                           {s === '@newLine' &&
                                                               <div style={{width: "100%"}}></div>
                                                           }
                                                           {!!s && s !== '@newLine' &&
                                                               <div style={{marginRight: "5px"}}>{s}</div>
                                                           }
                                                       </Fragment>
                                                   ))}
                                               </Fragment>
                                           );
                                       } else {
                                           // const id = currIndex;
                                           let blankName = str.substring(1, str.length - 1);

                                           return (
                                               <div key={i} className={`${styles.FITBBox} ${!!totalPoints ? styles.correct : ""}`}>
                                                   {!!totalPoints && renderAllCorrectOptions(question, blankName)}
                                               </div>
                                           );
                                       }
                                   })}

                               </span>
                            }

                            {questionType !== QUESTION_TYPES.FITB.name &&
                                <LatexHTMLInline>{queTitle}</LatexHTMLInline>
                            }

                            <div style={{height: 20}}/>


                            {questionType !== QUESTION_TYPES.CI.name && !!question.imageURL && !question.directLinkEvp &&
                                <ImageViewer
                                    width={360}
                                    height={170}
                                    alt={question.imageAlt}
                                    imageURL={question.imageURL}
                                    styles={{alignSelf: "center"}}
                                />
                            }
                            {!question.imageURL && !!question.directLinkEvp && isSafeIframeSrc(question.directLinkEvp) &&
                                <iframe allowFullScreen style={{width: 360, height: 240, alignSelf: "center"}}
                                        src={getSafeIframeSrc(question.directLinkEvp)}/>
                            }

                            {questionType === QUESTION_TYPES.CI.name && !!question.imageURL &&
                                <div className={ActivityEditorClasses.questionMediaViewerWrapper} style={{width: 360}}>
                                    <div className={ActivityEditorClasses.questionMediaViewer}>
                                        <ClickableImageNew
                                            selectedQuestion={question}
                                            disableDrag={true}
                                            showOptionArea={true}
                                        />
                                    </div>

                                </div>


                            }


                            <div style={{height: 20}}/>
                            {!!liveResponses && (questionType === QUESTION_TYPES.MCSS.name
                                    || questionType === QUESTION_TYPES.TF.name
                                    || questionType === QUESTION_TYPES.CI.name)
                                &&
                                <ViewLiveRespCountChart
                                    chartData={liveResponses}
                                    showCorrectAnswer={true}
                                    question={question}
                                    isExpanded={openedQuestionNo === serialNo}
                                    isShared={false}
                                />
                            }

                            {/*{!!liveResponses && isGeneralSA(questionType) &&*/}
                            {/*    <div className={classes.column} style={{gap: 10}} >*/}
                            {/*        {!!liveResponses && liveResponses.length > 0 && liveResponses.map((response, index) =>*/}
                            {/*            <div key={index}  className={responseClasses.allResponseCard}>*/}
                            {/*                {response}*/}
                            {/*            </div>*/}
                            {/*        )}*/}

                            {/*        {(!liveResponses || !liveResponses.length) &&*/}
                            {/*            <>*/}
                            {/*                <NoResultIllustration width={130} height={71} style={{alignSelf: "center", marginTop: 20}}/>*/}
                            {/*                <span style={{fontSize: 16, lineHeight: "19px", fontWeight: 600, alignSelf: "center"}}>*/}
                            {/*                    {NO_RESPONSES_TEXT}*/}
                            {/*                </span>*/}
                            {/*                <span style={{fontSize: 14, lineHeight: "16px", fontWeight: 400, alignSelf: "center"}}>*/}
                            {/*                  {SA_NO_RESPONSE_EXPLAIN_RELEASE_PAGE}*/}
                            {/*              </span>*/}
                            {/*            </>*/}
                            {/*        }*/}
                            {/*    </div>*/}
                            {/*}*/}

                            {/*{!!liveResponses && questionType === QUESTION_TYPES.FITB.name &&*/}
                            {/*    <div className={classes.column} style={{gap: 10}}>*/}
                            {/*        {liveResponses.map((response, index) =>*/}
                            {/*            <div key={index} className={responseClasses.allResponseCard}>*/}
                            {/*                <div>*/}
                            {/*                    {Object.keys(response).map((key, idx) =>*/}
                            {/*                        <div key={idx} >- {response[key]}</div>*/}
                            {/*                    )}*/}
                            {/*                </div>*/}
                            {/*            </div>*/}
                            {/*        )}*/}
                            {/*    </div>*/}
                            {/*}*/}


                            {/*{!!liveResponses && questionType === QUESTION_TYPES.WC.name &&*/}
                            {/*    <div*/}
                            {/*        style={{*/}
                            {/*            alignSelf: "center",*/}
                            {/*            width: "min(800px, 100%)",*/}
                            {/*            height: 300,*/}
                            {/*            backgroundColor: "#F6F6F6E6",*/}
                            {/*            border:  "1px solid #E6E6E6",*/}
                            {/*            borderRadius: 4,*/}
                            {/*            display: "flex", alignItems: "center", justifyContent: "center"*/}
                            {/*        }}*/}
                            {/*    >*/}
                            {/*        <WordCloudResult data={liveResponses} />*/}
                            {/*    </div>*/}
                            {/*}*/}

                            {!!liveResponses && questionType === QUESTION_TYPES.RK.name &&
                                <ViewLiveRespRK
                                    question={question}
                                    chartData={liveResponses}
                                    isExpanded={openedQuestionNo === serialNo}
                                />
                            }

                            {!!liveResponses && questionType === QUESTION_TYPES.MH.name &&
                                <Accordion.Root multiple className={classes.column} style={{gap: 10}} >
                                    {question.correctAnswers.filter(i => i.length > 1).map((key, index) =>
                                        <ViewLiveRespMH
                                            key={index}
                                            correctAnswers={question.correctAnswers}
                                            premise={key[0]}
                                            premiseIdx={index}
                                            data={liveResponses[key[0]]}
                                            shouldShowCorrect={true}
                                            isShared={false}
                                        />
                                    )}
                                </Accordion.Root>
                            }

                            {/*{!!liveResponses && questionType === QUESTION_TYPES.OE.name &&*/}
                            {/*    <ViewLiveRespOE originalData={liveResponses}/>*/}
                            {/*}*/}
                        </Accordion.Panel>
                    </Accordion.Item>
                );

            })}

        </Accordion.Root>
    );
}


function WarnIcon(props) {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g>
                <path d="M10.0003 18.3337C14.6027 18.3337 18.3337 14.6027 18.3337 10.0003C18.3337 5.39795 14.6027 1.66699 10.0003 1.66699C5.39795 1.66699 1.66699 5.39795 1.66699 10.0003C1.66699 14.6027 5.39795 18.3337 10.0003 18.3337Z" stroke="#E17100" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M10 13.3333V10" stroke="#E17100" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M10 6.66699H10.0083" stroke="#E17100" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
        </svg>

    );
}